import { t, useLanguage } from '../../i18n';
import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';



import { View, StyleSheet, FlatList, TouchableOpacity, ScrollView, Alert, Linking, TextInput as RNTextInput, Platform, Text } from 'react-native';



import { Card, Searchbar, Chip, Button, useTheme, ActivityIndicator, Menu, Divider, TextInput, Modal, Portal, Snackbar, RadioButton, SegmentedButtons, Dialog, IconButton, Tooltip } from 'react-native-paper';



import { Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';



import { Course } from '../../types';

import { getCourseSlotKey } from '../../utils/courseIdentity';



import { useSchedule } from '../../contexts/ScheduleContext';



import { useSyllabus } from '../../contexts/SyllabusContext';



import { useReviewGateContext } from '../../contexts/ReviewGateContext';



import { useGradeGateContext } from '../../contexts/GradeGateContext';



import { ThemePreferencesContext } from '../../contexts/ThemeContext';



import { trackEvent } from '../../firebase';



import { useScrollToTop, useIsFocused, useRoute } from '@react-navigation/native';









// ローカルデータ管理を使用 (コメントアウト)



// import { getCoursesFromLocalStorage, searchCoursesLocally, filterCoursesLocally, saveCoursesToLocalStorage } from '../../utils/localDataManager';



// 曜日別の授業データをインポート (コメントアウト)



// import { allCourses, coursesByDayMap } from '../../data/coursesByDay';







type CoursesScreenProps = {



  navigation: any;



};

const DEFAULT_SEMESTER_FILTER = '秋学期';







const CoursesScreen = ({ navigation }: CoursesScreenProps) => {
  useLanguage();



  const { toggleTheme, isDarkMode } = useContext(ThemePreferencesContext);



  const isFocused = useIsFocused();

  const route = useRoute<any>();
  const routeParams = route.params || {};
  const recoveryMode = routeParams.recoveryMode === true;
  const recoveryType = typeof routeParams.recoveryType === 'string' ? routeParams.recoveryType : 'review';
  const isGradeRecovery = recoveryMode && recoveryType === 'grade';
  const recoveryFromUnavailable = recoveryMode && routeParams.recoveryOrigin === 'unavailable';
  const lockedAcademicYearRaw = typeof routeParams.lockedAcademicYear === 'string' ? routeParams.lockedAcademicYear : '';
  const lockedSemesterRaw = typeof routeParams.lockedSemester === 'string' ? routeParams.lockedSemester : '';
  const lockedAcademicYearLabel = lockedAcademicYearRaw
    ? (lockedAcademicYearRaw.includes('年度') ? lockedAcademicYearRaw : `${lockedAcademicYearRaw}年度`)
    : '';
  const lockedSemesterLabel = lockedSemesterRaw
    ? (
      lockedSemesterRaw.includes('学期')
        ? lockedSemesterRaw
        : lockedSemesterRaw === '春'
          ? '春学期'
          : lockedSemesterRaw === '秋'
            ? '秋学期'
            : lockedSemesterRaw
    )
    : '';

  const [courses, setCourses] = useState<Course[]>([]);



  const [loading, setLoading] = useState(true);



  const [searchQuery, setSearchQuery] = useState('');



  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');



  const [dayFilter, setDayFilter] = useState('すべて');



  const [periodFilter, setPeriodFilter] = useState('すべて');



  const [semesterFilter, setSemesterFilter] = useState(DEFAULT_SEMESTER_FILTER);



  const [ondemandFilter, setOndemandFilter] = useState('すべて'); // New: Ondemand filter



  const [facultyFilter, setFacultyFilter] = useState('すべて'); // New: Faculty filter



  const [categoryFilter, setCategoryFilter] = useState('すべて'); // New: Category filter



  const [languageSubcategoryFilter, setLanguageSubcategoryFilter] = useState('すべて'); // New: Language subcategory filter



  const [academicYearFilter, setAcademicYearFilter] = useState('2026年度'); // Case: Default to "2026年度"







  // フィルターモーダル用の状態



  const [dayModalVisible, setDayModalVisible] = useState(false);



  const [periodModalVisible, setPeriodModalVisible] = useState(false);



  const [semesterModalVisible, setSemesterModalVisible] = useState(false);



  const [facultyModalVisible, setFacultyModalVisible] = useState(false); // New: Faculty Modal



  const [categoryModalVisible, setCategoryModalVisible] = useState(false); // New: Category Modal



  const [languageSubcategoryModalVisible, setLanguageSubcategoryModalVisible] = useState(false); // New: Language Subcategory Modal



  const [academicYearModalVisible, setAcademicYearModalVisible] = useState(false); // New: Academic Year Modal







  // スナックバー用の状態



  const [snackbarVisible, setSnackbarVisible] = useState(false);



  const [snackbarMessage, setSnackbarMessage] = useState('');







  // タブ切り替え状態



  const [activeTab, setActiveTab] = useState('search'); // 'search' | 'custom'







  // カスタム予定入力用の状態



  const [customCourseName, setCustomCourseName] = useState('');



  const [customCourseDay, setCustomCourseDay] = useState('月曜');



  const [customCoursePeriod, setCustomCoursePeriod] = useState('1限');



  const [customCourseRoom, setCustomCourseRoom] = useState('');







  // フィルター用・カスタム用共通で使う曜日・時限の選択肢 (すべてを除く)



  const exactDayOptions = ['月曜', '火曜', '水曜', '木曜', '金曜', 'オンデマンド'];



  const exactPeriodOptions = ['1限', '2限', '3限', '4限', '5限', '6限'];







  // カスタム予定入力用のモーダル (曜日・時限用)



  const [customDayModalVisible, setCustomDayModalVisible] = useState(false);



  const [customPeriodModalVisible, setCustomPeriodModalVisible] = useState(false);







  // テンプレート・カード管理用の状態



  const [newCardSaved, setNewCardSaved] = useState(false);







  // スケジュールコンテキストを使用



  const {



    addCourse,



    isCourseAdded,



    removeCourse,



    hasTimeConflict,



    isTermMismatch,



    userCourses,



    favoriteCustomCourses,



    addFavoriteCustomCourse,



    removeFavoriteCustomCourse,



    favoriteCourses,



    addFavoriteCourse,



    removeFavoriteCourse,



    isFavoriteCourse,



  } = useSchedule();



  const { syllabusCourses, isLoading: syllabusLoading, error: syllabusError } = useSyllabus();



  const {
    isGated: isReviewGated,
    loading: reviewGateLoading,
    status: reviewGateStatus,
    retry: retryReviewGate,
  } = useReviewGateContext();



  const {
    isGated: isGradeGated,
    loading: gradeGateLoading,
    status: gradeGateStatus,
    retry: retryGradeGate,
  } = useGradeGateContext();



  const searchbarInputRef = useRef<RNTextInput | null>(null);



  const flatListRef = useRef<FlatList>(null);







  useScrollToTop(flatListRef);







  const theme = useTheme();

  const recoveryColors = theme.colors as typeof theme.colors & {
    recovery: string;
    onRecovery: string;
    recoveryContainer: string;
    onRecoveryContainer: string;
  };







  // Filter options



  const dayOptions = ['すべて', '月曜', '火曜', '水曜', '木曜', '金曜'];



  const periodOptions = ['すべて', '1限', '2限', '3限', '4限', '5限', '6限'];



  const semesterOptions = ['すべて', '春学期', '秋学期']; // Options for "開講学期"



  const facultyOptions = ['すべて', '世界教養プログラム', '言語文化学部', '国際社会学部', '国際日本学部', '大学院総合国際学研究科'];



  const academicYearOptions = ['すべて', '2026年度', '2025年度']; // New: Academic Year Options - Filtered to 2026/2025







  const getCategoryOptions = (faculty: string) => {



    if (faculty === '世界教養プログラム') {



      return ['すべて', '基礎', '教養', '言語', '地域', '教職'];



    } else if (['言語文化学部', '国際社会学部', '国際日本学部', '大学院総合国際学研究科'].includes(faculty)) {



      return ['すべて', '導入', '概論', '専門'];



    }



    return ['すべて', '導入', '概論', '専門', '基礎', '教養', '言語', '地域', '教職'];



  };

  const showRecoveryBlockedMessage = () => {
    setSnackbarMessage(t("recovery mode中は講義詳細を開けません。時間割への追加・削除のみ利用できます。"));
    setSnackbarVisible(true);
  };

  useEffect(() => {
    if (!recoveryMode) return;

    const targetGateReady = isGradeRecovery
      ? gradeGateStatus === 'ready' && !gradeGateLoading
      : reviewGateStatus === 'ready' && !reviewGateLoading;
    const isTargetGateCleared = isGradeRecovery
      ? !isGradeGated && !gradeGateLoading
      : !isReviewGated && !reviewGateLoading;
    const shouldExitRecovery = recoveryFromUnavailable ? targetGateReady : isTargetGateCleared;

    if (!shouldExitRecovery) return;

    if (typeof navigation.setParams === 'function') {
      navigation.setParams({
        recoveryMode: false,
        recoveryOrigin: '',
        lockedAcademicYear: '',
        lockedSemester: '',
      });
    }
    setAcademicYearFilter('2026年度');
    setSemesterFilter(DEFAULT_SEMESTER_FILTER);
    setSnackbarMessage(
      recoveryFromUnavailable && (isGradeRecovery ? isGradeGated : isReviewGated)
        ? t("利用状況を確認しました。制限対象の機能にはまだアクセスできません")
        : t("ゲートが解除されたため、通常の履修検索に戻しました")
    );
    setSnackbarVisible(true);
  }, [
    recoveryMode,
    recoveryFromUnavailable,
    isGradeRecovery,
    isReviewGated,
    isGradeGated,
    reviewGateLoading,
    gradeGateLoading,
    reviewGateStatus,
    gradeGateStatus,
  ]);

  const retryTargetGate = () => {
    void (isGradeRecovery ? retryGradeGate() : retryReviewGate());
  };

  const handleCourseCardPress = (course: Course) => {
    if (recoveryMode) {
      showRecoveryBlockedMessage();
      return;
    }

    navigation.navigate('CourseEvaluation', { course });
  };

  useEffect(() => {
    if (!recoveryMode) return;

    if (lockedAcademicYearLabel) {
      setAcademicYearFilter(lockedAcademicYearLabel);
    }

    if (lockedSemesterLabel) {
      setSemesterFilter(lockedSemesterLabel);
    }
  }, [recoveryMode, lockedAcademicYearLabel, lockedSemesterLabel]);







  const categoryOptions = getCategoryOptions(facultyFilter);







  const category1Map: { [key: string]: string } = {



    '導入': 'ic',



    '概論': 'sc',



    '専門': 'mc',



    '基礎': 'fc',



    '教養': 'lac',



    '言語': 'lnc',



    '地域': 'arc',



    '教職': 'tc'



  };



  // 検索窓の特殊キーワード → category2 コード



  const searchKeywordCategory2Map: { [key: string]: string } = {



    'glip': 'gl',



    '教外': 'fl',



    '教養外国語': 'fl'



  };







  // glip 検索のレベル略記号 → name 検索用ラベル



  const glipLevelMap: { [key: string]: string } = {



    'a': '英語A',



    'b': '英語B',



    'c': '英語C'



  };



  // 言語カテゴリのサブ区分（category2）



  const languageSubcategoryMap: { [key: string]: string } = {



    '非モジュール': 'noml',



    'モジュール': 'ml',



    'GLIP': 'gl',



    '教養外国語': 'fl',



    '諸地域言語': 'rl',



    '基礎日本語': 'fj',



    '専門日本語': 'sj'



  };



  const languageSubcategoryOptions = ['すべて', ...Object.keys(languageSubcategoryMap)];







  // 曜日と曜日インデックスのマッピング



  const dayNameToIndex = {



    '月曜': 0,



    '火曜': 1,



    '水曜': 2,



    '木曜': 3,



    '金曜': 4



  };







  useEffect(() => {



    loadCourses();



  }, [syllabusCourses]);







  // 検索結果のAnalyticsを追跡



  useEffect(() => {



    if (filteredCourses.length >= 0) {



      trackEvent('search_performed', {



        search_query: debouncedSearchQuery,



        results_count: filteredCourses.length,



        filters: {



          day: dayFilter,



          period: periodFilter,



          semester: semesterFilter,



          ondemand: ondemandFilter,



          faculty: facultyFilter,



          category: categoryFilter,



          languageSubcategory: languageSubcategoryFilter,



          academicYear: academicYearFilter



        }



      });



    }



  }, [debouncedSearchQuery, dayFilter, periodFilter, semesterFilter, ondemandFilter, facultyFilter, categoryFilter, languageSubcategoryFilter, academicYearFilter]);







  // デバウンス処理: 入力が止まってから300ms後に検索を実行



  useEffect(() => {



    const handler = setTimeout(() => {



      setDebouncedSearchQuery(searchQuery);



    }, 300);







    return () => {



      clearTimeout(handler);



    };



  }, [searchQuery]);







  const loadCourses = async () => {



    try {



      setLoading(true);







      if (syllabusLoading) {



        // SyllabusContextがまだロード中なら待機



        return;



      }







      if (syllabusError) {



        console.error('Syllabusデータ読み込みエラー:', syllabusError);



        Alert.alert(t("エラー"), t("授業データの読み込みに失敗しました。"));



        setCourses([]);



        setLoading(false);



        return;



      }







      if (syllabusCourses && syllabusCourses.length > 0) {



        console.log(`${syllabusCourses.length}件の授業データをSyllabusContextから読み込みました`);



        setCourses(syllabusCourses);



      } else {



        console.log('SyllabusContextから利用可能な授業データがありませんでした。');



        setCourses([]);



      }







      setLoading(false);



    } catch (error) {



      console.error('授業データの処理エラー:', error);



      Alert.alert(t("エラー"), t("授業データの処理中にエラーが発生しました。"));



      setCourses([]);



      setLoading(false);



    }



  };







  const handleResetFilters = () => {



    setSearchQuery('');



    setDayFilter('すべて');



    setPeriodFilter('すべて');



    setSemesterFilter(recoveryMode && lockedSemesterLabel ? lockedSemesterLabel : DEFAULT_SEMESTER_FILTER);



    setOndemandFilter('すべて');



    setFacultyFilter('すべて');



    setCategoryFilter('すべて');



    setLanguageSubcategoryFilter('すべて');



    setAcademicYearFilter(recoveryMode && lockedAcademicYearLabel ? lockedAcademicYearLabel : '2026年度');







    // Analytics: フィルターリセットイベント



    trackEvent('filters_reset', {



      screen: 'courses'



    });



  };







  // フィルター変更時に自動的に先頭へスクロール



  useEffect(() => {



    if (flatListRef.current) {



      // わずかな遅延を入れることで、レンダリングとスクロールの競合を防ぎ、



      // ユーザーが「あ、変わった」と認識しやすくする



      const timer = setTimeout(() => {



        flatListRef.current?.scrollToOffset({ offset: 0, animated: true });



      }, 50);



      return () => clearTimeout(timer);



    }



  }, [debouncedSearchQuery, dayFilter, periodFilter, semesterFilter, ondemandFilter, facultyFilter, categoryFilter, languageSubcategoryFilter, academicYearFilter]);







  const filteredCourses = useMemo(() => {



    if (!courses || courses.length === 0) {



      return [];



    }







    let results = courses;







    if (debouncedSearchQuery.trim() !== '') {



      // 正規化関数をループ外で一回だけ定義（または高速化）



      // 全角スペースの削除と小文字化



      const normalize = (str: string | undefined | null) => {



        if (!str) return '';



        // 頻繁に呼ばれるため、単純な置換を使用



        return str.toLowerCase().replace(/\s+/g, '').replace(/　/g, '');



      };







      // 半角・全角スペースで分割してトークン化
      const tokens = debouncedSearchQuery
        .split(/[ \u3000]+/)
        .map(token => normalize(token))
        .filter(token => token !== '');



      if (tokens.length > 0) {



        let keywordCategory2: string | undefined;



        let searchTokens = tokens;



        const firstTokenKeyword = searchKeywordCategory2Map[tokens[0]];



        if (firstTokenKeyword) {



          keywordCategory2 = firstTokenKeyword;



          searchTokens = tokens.slice(1);



        }



        if (keywordCategory2 === 'gl' && searchTokens.length > 0 && glipLevelMap[searchTokens[0]]) {



          searchTokens = [normalize(glipLevelMap[searchTokens[0]]), ...searchTokens.slice(1)];



        }



        if (keywordCategory2) {



          // 特殊キーワード検索：category2 で絞り込む



          results = results.filter(course => (course as any).category2 === keywordCategory2);



        }



        if (searchTokens.length > 0) {



          results = results.filter(course => {



            const name = normalize(course.name);



            const professor = normalize(course.professor);



            const title = normalize(course.title);



            return searchTokens.every(token =>



              name.includes(token) ||



              professor.includes(token) ||



              title.includes(token)



            );



          });



        }



      }



    }







    if (dayFilter !== 'すべて') {



      const dayIndex = dayOptions.indexOf(dayFilter);



      if (dayIndex > 0) {



        results = results.filter(course => course.dayOfWeek === dayIndex);



      }



    }







    if (periodFilter !== 'すべて') {



      const periodNumber = parseInt(periodFilter.replace('限', ''));



      results = results.filter(course => course.period === periodNumber);



    }







    if (semesterFilter !== 'すべて') {



      results = results.filter(course => course.semester === semesterFilter);



    }







    if (ondemandFilter === 'オンデマンド') {



      results = results.filter(course => course.room === 'ｵﾝﾃﾞﾏﾝﾄﾞ');



    }







    if (facultyFilter !== 'すべて') {



      const facultyCodeMap: { [key: string]: string[] } = {



        '世界教養プログラム': ['世界教養プログラム', 'gla'],



        '言語文化学部': ['言語文化学部', 'lc', 'cl'],



        '国際社会学部': ['国際社会学部', 'ia', 'is'],



        '国際日本学部': ['国際日本学部', 'js', 'ij'],



        '大学院総合国際学研究科': ['大学院総合国際学研究科', 'pg']



      };



      const allowedFaculties = facultyCodeMap[facultyFilter] || [facultyFilter];







      results = results.filter(course => {



        const courseFaculty = (course as any).faculty;



        return allowedFaculties.includes(courseFaculty);



      });



    }







    if (categoryFilter !== 'すべて') {



      const code = category1Map[categoryFilter];



      results = results.filter(course => (course as any).category1 === code);



    }







    if (categoryFilter === '言語' && languageSubcategoryFilter !== 'すべて') {



      const code = languageSubcategoryMap[languageSubcategoryFilter];



      results = results.filter(course => (course as any).category2 === code);



    }







    if (academicYearFilter !== 'すべて') {



      const yearStr = academicYearFilter.replace('年度', '');



      const yearNum = parseInt(yearStr, 10);



      results = results.filter(course => {



        const courseYear = (course as any).academicYear;



        if (typeof courseYear === 'number') {



          return courseYear === yearNum;



        } else if (typeof courseYear === 'string') {



          return parseInt(courseYear.replace('年度', ''), 10) === yearNum;



        }



        return false;



      });



    }







    return results;



    // eslint-disable-next-line react-hooks/exhaustive-deps



  }, [



    courses, debouncedSearchQuery, dayFilter, periodFilter, semesterFilter,



    ondemandFilter, facultyFilter, categoryFilter, languageSubcategoryFilter, academicYearFilter



  ]);







  const renderCourseCard = ({ item }: { item: Course }) => {



    const isAdded = isCourseAdded(item.id, item.academicYear);



    const mismatchType = isTermMismatch(item);



    const hasTermMismatch = !isAdded && mismatchType !== 'none';



    let hasConflict = false;



    if (!isAdded && !hasTermMismatch && typeof item.dayOfWeek === 'number' && typeof item.period === 'number') {



      hasConflict = hasTimeConflict(item.dayOfWeek, item.period);



    }



    // 曜日と時限の表示用文字列を生成 (SyllabusScreen.tsxのヘルパー関数を参考に)



    const dayOfWeekStrings = ["月", "火", "水", "木", "金"]; // Adjusted to Mon-Fri as per data



    let timeDisplay = '未定';



    if (typeof item.dayOfWeek === 'number' && item.dayOfWeek >= 1 && item.dayOfWeek <= dayOfWeekStrings.length &&



      typeof item.period === 'number') {



      timeDisplay = `${dayOfWeekStrings[item.dayOfWeek - 1]}${item.period}限`;



    }







    // 学部名のフォーマット関数 (コードから日本語名へ変換)



    const formatFaculty = (facultyCode: string | undefined): string => {



      if (!facultyCode) return '';



      const displayMap: { [key: string]: string } = {



        'lc': '言語文化学部',



        'cl': '言語文化学部',



        'ia': '国際社会学部',



        'is': '国際社会学部',



        'js': '国際日本学部',



        'ij': '国際日本学部',



        'pg': '大学院総合国際学研究科',



        'gla': '世界教養プログラム',



        // 2025年度以前のデータで既にフルネームの場合はそのまま返すためのマッピング



        '言語文化学部': '言語文化学部',



        '国際社会学部': '国際社会学部',



        '国際日本学部': '国際日本学部',



        '大学院総合国際学研究科': '大学院総合国際学研究科',



        '世界教養プログラム': '世界教養プログラム'



      };



      return displayMap[facultyCode] || facultyCode;



    };







    return (



      <TouchableOpacity onPress={() => handleCourseCardPress(item)}>



        <Card style={styles.card}>



          <Card.Content>



            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>



              <View style={{ flex: 1 }}>



                <Text style={[styles.cardTitle, { color: theme.colors.onSurface }]}>{item.name}</Text>



                {item.title && <Text style={[styles.cardSubtitle, { color: theme.colors.onSurfaceVariant }]}>{item.title}</Text>}



              </View>



              <Tooltip title={isFavoriteCourse(item.id, item.academicYear) ? t("お気に入りから削除") : t("お気に入りに追加")}>



                <IconButton

                  accessibilityLabel={isFavoriteCourse(item.id, item.academicYear) ? t('お気に入りから削除') : t('お気に入りに追加')}



                  icon={() => <MaterialCommunityIcons 



                    name={isFavoriteCourse(item.id, item.academicYear) ? 'heart' : 'heart-outline'} 



                    size={24} 



                    color={isFavoriteCourse(item.id, item.academicYear) ? '#e75480' : theme.colors.onSurfaceVariant} 



                  />}



                  iconColor={isFavoriteCourse(item.id, item.academicYear) ? '#e75480' : theme.colors.onSurfaceVariant}



                  size={24}



                  onPress={async (e) => {



                    e.stopPropagation();



                    try {
                      if (isFavoriteCourse(item.id, item.academicYear)) {
                        await removeFavoriteCourse(item.id, item.academicYear);
                        setSnackbarMessage(t("{0} をお気に入りから削除しました", [item.name]));
                      } else {
                        await addFavoriteCourse(item);
                        setSnackbarMessage(t("{0} をお気に入りに追加しました", [item.name]));
                      }
                    } catch (error) {
                      console.error('[CoursesScreen] Failed to update favorites', error);
                      setSnackbarMessage(t("お気に入りを保存できませんでした。もう一度お試しください。"));
                    }



                    setSnackbarVisible(true);



                  }}



                  style={{ margin: 0, marginTop: -8, marginRight: -8 }}



                />



              </Tooltip>



            </View>



            {item.professor && <Text style={[styles.cardText, { color: theme.colors.onSurface }]}>{t("担当教員:")} {item.professor}</Text>}



            <Text style={[styles.cardText, { color: theme.colors.onSurface }]}>{t("時間:")} {t(timeDisplay)}{item.room ? t("　教室：{0}", [item.room]) : ''}</Text>



            {item.class_name && <Text style={[styles.cardText, { color: theme.colors.onSurface }]}>{t("クラス:")} {item.class_name}</Text>}



            {(item as any).faculty && <Text style={[styles.cardText, { color: theme.colors.onSurface }]}>{t("学部:")} {t(formatFaculty((item as any).faculty))}</Text>}








            <View style={styles.buttonContainer}>



              {item.syllabusUrl && (



                <Button



                  mode="outlined"



                  onPress={() => {



                    if (recoveryMode) {

                      showRecoveryBlockedMessage();

                      return;

                    }

                    if (item.syllabusUrl) {



                      Linking.openURL(item.syllabusUrl);



                    }



                  }}



                  style={styles.button}



                  compact={true}



                  labelStyle={{ fontSize: 13, marginHorizontal: 0 }}



                  contentStyle={{ height: 36, paddingHorizontal: 4 }}



                >



                  {t("シラバスを見る")}



                </Button>



              )}



              <Button



                mode={isAdded ? "contained" : "outlined"}



                style={[



                  styles.button,



                  isAdded ? styles.addedButton : null,



                  (hasConflict || hasTermMismatch) && !isAdded ? styles.conflictButton : null



                ]}



                onPress={(e) => {



                  e.stopPropagation();



                  if (isAdded) {



                    removeCourse(item.id);



                    setSnackbarMessage(t("{0} を時間割から削除しました", [item.name]));



                    setSnackbarVisible(true);



                  } else {



                    handleAddToSchedule(item);



                  }



                }}



                icon={(!isAdded && (hasConflict || hasTermMismatch)) ? () => <MaterialCommunityIcons name="alert" size={16} color={theme.colors.primary} /> : undefined}



                compact={true}



                labelStyle={{ fontSize: 13, marginHorizontal: 0 }}



                contentStyle={{ height: 36, paddingHorizontal: 4 }}



              >



                {isAdded ? t("追加済み") :



                  (mismatchType === 'year' || mismatchType === 'both') ? t("年度が異なります") :



                    mismatchType === 'semester' ? t("学期が異なります") :



                      hasConflict ? t("重複あり") : t("追加")}



              </Button>



            </View>



          </Card.Content>



        </Card>



      </TouchableOpacity>



    );



  };







  // フィルターモーダルのレンダリング



  const renderFilterModal = (



    visible: boolean,



    setVisible: React.Dispatch<React.SetStateAction<boolean>>,



    options: string[],



    currentValue: string,



    setValue: (value: string) => void,



    title: string,



    renderOptionAccessory?: (option: string, isSelected: boolean) => React.ReactNode



  ) => (



    <Modal



      visible={visible}



      onDismiss={() => setVisible(false)}



      contentContainerStyle={[styles.modalContainer, { backgroundColor: theme.colors.elevation.level3 }]}



    >



      <Text style={styles.modalTitle}>{title}</Text>



      <ScrollView keyboardShouldPersistTaps="handled">



        {options.map((option) => (



          <TouchableOpacity



            key={option}



            style={[



              styles.modalOption,



              { borderBottomColor: theme.colors.outlineVariant },



              currentValue === option && { backgroundColor: isDarkMode ? theme.colors.onSurfaceVariant + '20' : '#fff5f8' }



            ]}



            onPress={() => {



              setValue(option);



              setVisible(false);



            }}



          >



            <Text



              style={[



                styles.modalOptionText,



                { color: theme.colors.onSurface },



                currentValue === option && { color: theme.colors.primary, fontWeight: 'bold' }



              ]}



            >



              {t(option)}



            </Text>



            {renderOptionAccessory



              ? renderOptionAccessory(option, currentValue === option)



              : currentValue === option && (



                <MaterialCommunityIcons name="check" size={20} color="#e75480" />



              )}



          </TouchableOpacity>



        ))}



      </ScrollView>



    </Modal>



  );







  const handleAddToSchedule = async (course: Course) => {



    // 既に同じIDの授業が追加されているかチェック



    if (isCourseAdded(course.id, course.academicYear)) {



      setSnackbarMessage(t("この授業はすでに時間割に追加されています"));



      setSnackbarVisible(true);



      return;



    }







    // 時間割に追加する前に時間帯の重複をチェック



    let hasConflictCheck = false;



    if (typeof course.dayOfWeek === 'number' && typeof course.period === 'number') {



      hasConflictCheck = hasTimeConflict(course.dayOfWeek, course.period);



    }







    if (hasConflictCheck) {



      // 時間帯が重複している場合はエラーを表示してブロック



      setSnackbarMessage(t("時間重複エラー：既に別の予定があります。追加するには先に既存の予定を削除してください。"));



      setSnackbarVisible(true);



      return;



    }







    const result = await addCourse(course);



    if (result.success) {



      setSnackbarMessage(t("{0}を時間割に追加しました", [course.name]));



      setSnackbarVisible(true);



    } else {



      if (result.errorType === 'term_mismatch') {



        // ユーザーの要望により、追加はブロックするが警告は出さない



      } else if (result.errorType === 'already_added') {



        setSnackbarMessage(t("この授業はすでに時間割に追加されています"));



        setSnackbarVisible(true);



      } else {



        setSnackbarMessage(t("{0}の追加に失敗しました。ログイン状態などを確認してください。{1}", [course.name, result.conflictCourse ? t(' 時間重複の可能性があります。') : '']));



        setSnackbarVisible(true);



      }



    }



  };







  const handleAddCustomCourse = async () => {



    if (!customCourseName.trim()) {



      setSnackbarMessage(t("予定名を入力してください"));



      setSnackbarVisible(true);



      return;



    }







    const isOnDemand = customCourseDay === 'オンデマンド';



    const dayIndex = isOnDemand ? 0 : exactDayOptions.indexOf(customCourseDay) + 1; // 1:Mon, 2:Tue...



    const periodNumber = parseInt(customCoursePeriod.replace('限', ''));







    const customCourse: Course = {



      id: `custom_${Date.now()}`,



      name: customCourseName.trim(),



      dayOfWeek: dayIndex,



      period: periodNumber,



      room: customCourseRoom.trim() || undefined,



      color: '#808080', // Set default color on creation



      isCustom: true, // 履修者カウントから除外されるフラグ



      // 必須ではないが、表示上あると便利なダミーデータ



      faculty: 'カスタム予定',



      professor: 'マイ予定',



      academicYear: '2026年度', // TODO: 動的にするかコンテキストから取得



      semester: '春学期',      // TODO: 同上



    };







    // オンデマンドの場合は時間重複チェックをスキップ



    if (!isOnDemand) {



      const hasConflictCheck = hasTimeConflict(dayIndex, periodNumber);



      if (hasConflictCheck) {



        setSnackbarMessage(t("時間重複エラー：既に別の予定があります。追加するには先に既存の予定を削除してください。"));



        setSnackbarVisible(true);



        return;



      }



    }







    const result = await addCourse(customCourse);



    if (result.success) {



      setSnackbarMessage(t("{0} を時間割に追加しました", [customCourse.name]));



      setCustomCourseName('');



      setCustomCourseRoom('');



    } else {



      setSnackbarMessage(t("追加に失敗しました。"));



    }



    setSnackbarVisible(true);



  };







  // --- マイカード（独自予定）管理機能 ---



  const onSaveToCardsPress = async () => {



    if (!customCourseName.trim()) {



      setSnackbarMessage(t("予定名を入力してください"));



      setSnackbarVisible(true);



      return;



    }







    const isOnDemand = customCourseDay === 'オンデマンド';



    const dayIndex = isOnDemand ? 0 : exactDayOptions.indexOf(customCourseDay) + 1;



    const periodNumber = parseInt(customCoursePeriod.replace('限', ''));







    const cardCourse: Course = {



      id: `fav_temp_${Date.now()}`,



      name: customCourseName.trim(),



      room: customCourseRoom.trim() || undefined,



      dayOfWeek: dayIndex,



      period: periodNumber,



      color: '#808080', // Set default color on card creation



      isCustom: true,



      faculty: 'カスタムカード',



      professor: 'マイカード'



    };







    try {



      await addFavoriteCustomCourse(cardCourse);



      setSnackbarMessage(t("「{0}」をカードとして保存しました", [cardCourse.name]));



      setSnackbarVisible(true);



    } catch (error) {



      setSnackbarMessage(t("カードの保存に失敗しました"));



      setSnackbarVisible(true);



    }



  };







  const onUseCardPress = (card: Course) => {



    setCustomCourseName(card.name);



    setCustomCourseRoom(card.room || '');







    if (card.dayOfWeek && card.dayOfWeek >= 1 && card.dayOfWeek <= 5) {



      setCustomCourseDay(exactDayOptions[card.dayOfWeek - 1]);



    }



    if (card.period) {



      setCustomCoursePeriod(`${card.period}限`);



    }







    setSnackbarMessage(t("「{0}」の内容をフォームに反映しました", [card.name]));



    setSnackbarVisible(true);



  };







  const onDeleteCardPress = async (card: Course) => {



    const doDelete = async () => {



      try {



        await removeFavoriteCustomCourse(card.id);



        setSnackbarMessage(t("カード「{0}」を削除しました", [card.name]));



        setSnackbarVisible(true);



      } catch (error) {



        setSnackbarMessage(t("削除に失敗しました"));



        setSnackbarVisible(true);



      }



    };







    if (Platform.OS === 'web') {



      if (window.confirm(t("「{0}」を削除してもよろしいですか？", [card.name]))) {



        await doDelete();



      }



    } else {



      Alert.alert(



        t("カードの削除"),



        t("「{0}」を削除してもよろしいですか？", [card.name]),



        [



          { text: t("キャンセル"), style: 'cancel' },



          {



            text: t("削除する"),



            style: 'destructive',



            onPress: doDelete



          }



        ]



      );



    }



  };







  return (



    <>


      <View style={[styles.container, { backgroundColor: theme.colors.background }]}>



      <Portal>



        {/* 検索用フィルターモーダル */}



        {renderFilterModal(dayModalVisible, setDayModalVisible, dayOptions, dayFilter, setDayFilter, t("曜日を選択"))}



        {renderFilterModal(periodModalVisible, setPeriodModalVisible, periodOptions, periodFilter, setPeriodFilter, t("時限を選択"))}



        {renderFilterModal(semesterModalVisible, setSemesterModalVisible, semesterOptions, semesterFilter, setSemesterFilter, t("開講学期を選択"))}



        {renderFilterModal(facultyModalVisible, setFacultyModalVisible, facultyOptions, facultyFilter, (newFaculty) => {



          setFacultyFilter(newFaculty);



          // If the new faculty doesn't support the current category, reset it



          const newCategoryOptions = getCategoryOptions(newFaculty);



          if (!newCategoryOptions.includes(categoryFilter) && categoryFilter !== 'すべて') {



            setCategoryFilter('すべて');



            setLanguageSubcategoryFilter('すべて');



          }



        }, t("学部を選択"))}



        {renderFilterModal(categoryModalVisible, setCategoryModalVisible, categoryOptions, categoryFilter, (newCategory) => {



          setCategoryFilter(newCategory);



          if (newCategory === '言語') {



            setLanguageSubcategoryModalVisible(true);



          } else {



            setLanguageSubcategoryFilter('すべて');



          }



          setCategoryModalVisible(false);



        }, t("カテゴリを選択"), (option, isSelected) => {



          if (option === '言語') {



            return <MaterialCommunityIcons name="chevron-right" size={20} color={theme.colors.primary} />;



          }



          if (isSelected) {



            return <MaterialCommunityIcons name="check" size={20} color="#e75480" />;



          }



          return null;



        })}



        {renderFilterModal(languageSubcategoryModalVisible, setLanguageSubcategoryModalVisible, languageSubcategoryOptions, languageSubcategoryFilter, (newSubcategory) => {



          setLanguageSubcategoryFilter(newSubcategory);



          setLanguageSubcategoryModalVisible(false);



        }, t("言語区分を選択"))}



        {renderFilterModal(academicYearModalVisible, setAcademicYearModalVisible, academicYearOptions, academicYearFilter, setAcademicYearFilter, t("開講年度を選択"))}







        {renderFilterModal(customDayModalVisible, setCustomDayModalVisible, exactDayOptions, customCourseDay, setCustomCourseDay, t("曜日を選択"))}



        {renderFilterModal(customPeriodModalVisible, setCustomPeriodModalVisible, exactPeriodOptions, customCoursePeriod, setCustomCoursePeriod, t("時限を選択"))}



      </Portal>







      <View style={[styles.header, recoveryMode && { backgroundColor: recoveryColors.recovery }]}>



        <TouchableOpacity



          onPress={() => {



            if (activeTab === 'search') flatListRef.current?.scrollToOffset({ offset: 0, animated: true });



          }}



          activeOpacity={0.7}



        >



          <View style={styles.recoveryTitleRow}>

            {recoveryMode && (

              <Ionicons name="lock-closed" size={20} color={recoveryColors.onRecovery} style={{ marginRight: 8 }} />

            )}

            <Text style={styles.title}>
              {recoveryMode
                ? (recoveryFromUnavailable
                  ? t("利用状況未確認の履修検索")
                  : (isGradeRecovery ? t("成績入力用履修検索") : t("レビュー用履修検索")))
                : t("履修検索")}
            </Text>

          </View>



        </TouchableOpacity>



      </View>

      







      <View style={{ flexDirection: 'row', justifyContent: 'space-around', backgroundColor: recoveryMode ? recoveryColors.recovery : '#e75480', paddingTop: 0, elevation: 0 }}>



        {[



          { key: 'search', label: t("講義") },



          { key: 'custom', label: t("カスタム") },



          { key: 'favorite', label: t("お気に入り") },



        ].map((tab) => {



          const isSelected = activeTab === tab.key;



          return (



            <TouchableOpacity



              key={tab.key}



              style={{



                flex: 1,



                paddingVertical: 12,



                paddingHorizontal: 8,



                borderBottomWidth: 3,



                borderBottomColor: isSelected ? '#ffffff' : 'transparent',



                alignItems: 'center',



                justifyContent: 'center',



              }}



              onPress={() => setActiveTab(tab.key)}



            >



              <Text



                style={{



                  fontSize: 15,



                  fontWeight: isSelected ? 'bold' : 'normal',



                  color: isSelected ? '#ffffff' : 'rgba(255, 255, 255, 0.7)',



                }}



              >



                {t(tab.label)}



              </Text>



            </TouchableOpacity>



          );



        })}



      </View>





      {recoveryMode && (

        <View style={[styles.recoveryBanner, { backgroundColor: recoveryColors.recoveryContainer }]}>

          <Ionicons name="lock-closed" size={20} color={recoveryColors.recovery} />

          <View style={styles.recoveryBannerTextWrap}>

            <View style={styles.recoveryBannerTitleRow}>

              <Text style={[styles.recoveryBannerTitle, { color: recoveryColors.onRecoveryContainer }]}>

                {recoveryFromUnavailable
                  ? t("利用状況未確認の復旧モード")
                  : (isGradeRecovery ? t("成績入力用検索モード") : t("レビュー用検索モード"))}

              </Text>

            </View>

            <Text style={[styles.recoveryBannerDescription, { color: recoveryColors.onRecoveryContainer }]}>

              {recoveryFromUnavailable
                ? t("利用状況を確認できないため、履修検索と時間割への追加・削除だけ利用できます。授業詳細、レビュー、成績入力は制限されています。")
                : (isGradeRecovery
                  ? t("開講年度・開講学期は固定されています。成績を入力する授業を選択してください。")
                  : t("開講年度・開講学期は固定されています。レビューを投稿する授業を選択してください。"))}

            </Text>

            {recoveryFromUnavailable && (
              <Button mode="contained" onPress={retryTargetGate} style={styles.recoveryRetryButton}>
                {t("利用状況を再確認")}
              </Button>
            )}

          </View>

        </View>

      )}





      {activeTab === 'custom' ? (



        <ScrollView style={styles.customContainer} keyboardShouldPersistTaps="handled">



          <Card style={styles.customCard}>



            <Card.Content>



              <Text style={[styles.customCardTitle, { color: theme.colors.onSurface }]}>{t("予定を追加")}</Text>



              <Text style={[styles.customCardDescription, { color: theme.colors.onSurfaceVariant }]}>



                {t("サークルやアルバイトなど、大学の授業以外の予定を時間割に追加できます。")}



              </Text>







              <TextInput



                mode="outlined"



                label={t("予定名 (必須)")}



                placeholder={t("例: バイト、サークル")}



                value={customCourseName}



                onChangeText={setCustomCourseName}



                style={styles.customInput}



              />







              <TextInput



                mode="outlined"



                label={t("場所/時間 (任意)")}



                placeholder={t("例: サークル棟、12:00〜13:00")}



                value={customCourseRoom}



                onChangeText={setCustomCourseRoom}



                style={styles.customInput}



              />







              <View style={styles.customSelectRow}>



                <View style={styles.customSelectCol}>



                  <Text style={[styles.customLabel, { color: theme.colors.onSurfaceVariant }]}>{t("曜日")}</Text>



                  <TouchableOpacity



                    style={[



                      styles.selectContainer,



                      {



                        backgroundColor: isDarkMode ? theme.colors.elevation.level1 : '#ffffff',



                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                        borderWidth: 1.2,



                      }



                    ]}



                    onPress={() => setCustomDayModalVisible(true)}



                  >



                    <TextInput



                      value={t(customCourseDay)}



                      style={[styles.select, { backgroundColor: 'transparent' }]}



                      right={<TextInput.Icon icon={() => <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                      editable={false}



                      underlineColor="transparent"



                      activeUnderlineColor="transparent"



                    />



                    <View style={StyleSheet.absoluteFill} />



                  </TouchableOpacity>



                </View>







                <View style={styles.customSelectCol}>



                  <Text style={[styles.customLabel, { color: theme.colors.onSurfaceVariant }]}>{t("時限")}</Text>



                  <TouchableOpacity



                    style={[



                      styles.selectContainer,



                      {



                        backgroundColor: isDarkMode ? theme.colors.elevation.level1 : '#ffffff',



                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                        borderWidth: 1.2,



                      }



                    ]}



                    onPress={() => setCustomPeriodModalVisible(true)}



                  >



                    <TextInput



                      value={t(customCoursePeriod)}



                      style={[styles.select, { backgroundColor: 'transparent' }]}



                      right={<TextInput.Icon icon={() => <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                      editable={false}



                      underlineColor="transparent"



                      activeUnderlineColor="transparent"



                    />



                    <View style={StyleSheet.absoluteFill} />



                  </TouchableOpacity>



                </View>



              </View>







              <View style={{ flexDirection: 'row', gap: 8 }}>



                <Button



                  mode="contained"



                  onPress={handleAddCustomCourse}



                  style={[styles.customAddButton, { flex: 2 }]}



                  icon={() => <MaterialCommunityIcons name="plus" size={20} color="#fff" />}



                >



                  {t("時間割に追加")}



                </Button>



                <Button



                  mode="outlined"



                  onPress={onSaveToCardsPress}



                  style={[styles.customAddButton, { flex: 1, borderColor: theme.colors.primary }]}



                  compact



                  icon={() => <MaterialCommunityIcons name="star-outline" size={20} color={theme.colors.primary} />}



                >



                  {t("保存")}



                </Button>



              </View>



            </Card.Content>



          </Card>











          {/* 保存済みのマイ予定カードセクション */}



          {favoriteCustomCourses && favoriteCustomCourses.length > 0 && (



            <View style={styles.cardSection}>



              <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 6 }}>



                <Text style={[styles.sectionHeader, { color: theme.colors.onSurface }]}>{t("保存済み")}</Text>



                <View style={styles.savedBadge}>



                  <Text style={styles.savedBadgeText}>{favoriteCustomCourses.length}</Text>



                </View>



              </View>



              <Text style={[styles.customCardDescription, { color: theme.colors.onSurfaceVariant }]}>



                {t("保存済みの予定をタップすると上部のフォームに保存した情報が入力されます。")}



              </Text>



              <View style={{ gap: 10 }}>



                {favoriteCustomCourses.map((card, index) => (



                  <TouchableOpacity



                    key={card.id}



                    style={[styles.savedCardRow, { backgroundColor: theme.colors.surface }]}



                    onPress={() => onUseCardPress(card)}



                    activeOpacity={0.7}



                  >



                    {/* 番号バッジ */}



                    <View style={styles.savedCardBadge}>



                      <Text style={styles.savedCardBadgeText}>{index + 1}</Text>



                    </View>







                    {/* カード情報 */}



                    <View style={{ flex: 1 }}>



                      <Text style={[styles.savedCardName, { color: theme.colors.onSurface }]} numberOfLines={1}>



                        {card.name}



                      </Text>



                      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 3 }}>



                        {card.dayOfWeek && card.period && (



                          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}>



                            <MaterialCommunityIcons name="clock-outline" size={12} color={theme.colors.onSurfaceVariant} />



                            <Text style={[styles.savedCardMeta, { color: theme.colors.onSurfaceVariant }]}>



                              {t('{0}曜{1}限', [t(['月', '火', '水', '木', '金'][card.dayOfWeek - 1] || ''), card.period])}
                            </Text>



                          </View>



                        )}



                        {card.room && (



                          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}>



                            <MaterialCommunityIcons name="map-marker-outline" size={12} color={theme.colors.onSurfaceVariant} />



                            <Text style={[styles.savedCardMeta, { color: theme.colors.onSurfaceVariant }]} numberOfLines={1}>



                              {card.room}



                            </Text>



                          </View>



                        )}



                      </View>



                    </View>







                    {/* 削除ボタン */}



                    <TouchableOpacity



                      style={styles.savedCardDeleteBtn}



                      onPress={(e) => {



                        e.stopPropagation();



                        onDeleteCardPress(card);



                      }}



                      activeOpacity={0.7}



                    >



                      <MaterialCommunityIcons name="trash-can" size={20} color={theme.colors.error} />



                    </TouchableOpacity>



                  </TouchableOpacity>



                ))}



              </View>



            </View>



          )}







          <View style={{ height: 100 }} />



        </ScrollView>



      ) : activeTab === 'favorite' ? (



        <FlatList



          ref={flatListRef}



          data={favoriteCourses}



          extraData={userCourses}



          keyboardShouldPersistTaps="handled"



          renderItem={renderCourseCard}



          keyExtractor={(item) => getCourseSlotKey(item)}



          ListEmptyComponent={



            <View style={[styles.container, styles.loadingContainer, { backgroundColor: theme.colors.background }]}>



              <Text style={{ marginTop: 10, color: theme.colors.onSurfaceVariant }}>{t("お気に入りに登録された講義はありません")}</Text>



            </View>



          }



          contentContainerStyle={styles.listContentContainer}



        />



      ) : loading && courses.length === 0 ? (



        <View style={[styles.container, styles.loadingContainer, { backgroundColor: theme.colors.background }]}>



          <ActivityIndicator animating={true} size="large" />



          <Text style={{ marginTop: 10 }}>{t("授業データを読み込んでいます...")}</Text>



        </View>



      ) : (



        <FlatList



          ref={flatListRef}



          data={filteredCourses}



          extraData={userCourses}



          keyboardShouldPersistTaps="handled"



          renderItem={renderCourseCard}



          keyExtractor={(item) => getCourseSlotKey(item)}



          ListHeaderComponent={



            <View style={[



              styles.searchContainer,



              { backgroundColor: isDarkMode ? '#1a1625' : '#f5f1ff' }



            ]}>



              {/* Searchbar row */}



              <View style={styles.filterRow}>



                <View style={styles.filterColumn}>



                  <Searchbar



                    placeholder={t("科目名、教員名などで検索")}



                    placeholderTextColor={isDarkMode ? '#A0AEC0' : 'gray'}



                    onChangeText={setSearchQuery}



                    value={searchQuery}



                    style={[



                      styles.searchBar,



                      {



                        backgroundColor: isDarkMode ? theme.colors.elevation.level3 : '#ffffff',



                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                        borderWidth: 1.2,



                      }



                    ]}



                    ref={searchbarInputRef as any}



                    iconColor={isDarkMode ? theme.colors.primary : 'gray'}



                    clearIcon={({ size, color }) => (



                      <MaterialCommunityIcons name="close" size={size} color={color} />



                    )}



                    icon={() => <MaterialCommunityIcons name="magnify" size={24} color={isDarkMode ? theme.colors.primary : 'gray'} />}



                  />



                </View>



              </View>







              <View style={styles.filterRow}>



                <View style={styles.filterColumn}>



                  <Text style={[styles.filterLabel, { color: isDarkMode ? theme.colors.onSurfaceVariant : theme.colors.onSurfaceVariant }]}>{t("曜日")}</Text>



                  <TouchableOpacity



                    style={[



                      styles.selectContainer,



                      {



                        backgroundColor: isDarkMode ? theme.colors.elevation.level1 : '#ffffff',



                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                        borderWidth: 1.2,



                      }



                    ]}



                    onPress={() => setDayModalVisible(true)}



                  >



                    <TextInput



                      value={t(dayFilter)}



                      style={[styles.select, { backgroundColor: 'transparent' }]}



                      right={<TextInput.Icon icon={() => <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                      editable={false}



                      underlineColor="transparent"



                      activeUnderlineColor="transparent"



                    />



                    <View style={StyleSheet.absoluteFill} />



                  </TouchableOpacity>



                </View>







                <View style={styles.filterColumn}>



                  <Text style={[styles.filterLabel, { color: isDarkMode ? theme.colors.onSurfaceVariant : theme.colors.onSurfaceVariant }]}>{t("時間帯")}</Text>



                  <TouchableOpacity



                    style={[



                      styles.selectContainer,



                      {



                        backgroundColor: isDarkMode ? theme.colors.elevation.level1 : '#ffffff',



                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                        borderWidth: 1.2,



                      }



                    ]}



                    onPress={() => setPeriodModalVisible(true)}



                  >



                    <TextInput



                      value={t(periodFilter)}



                      style={[styles.select, { backgroundColor: 'transparent' }]}



                      right={<TextInput.Icon icon={() => <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                      editable={false}



                      underlineColor="transparent"



                      activeUnderlineColor="transparent"



                    />



                    <View style={StyleSheet.absoluteFill} />



                  </TouchableOpacity>



                </View>



              </View>







              {/* 2行目: 開講年度・開講学期 */}



              <View style={styles.filterRow}>



                <View style={styles.filterColumn}>



                  <Text style={[styles.filterLabel, { color: isDarkMode ? theme.colors.onSurfaceVariant : theme.colors.onSurfaceVariant }]}>{t("開講年度")}</Text>



                  <TouchableOpacity



                    style={[



                      styles.selectContainer,



                      {



                        backgroundColor: recoveryMode ? theme.colors.surfaceVariant : (isDarkMode ? theme.colors.elevation.level1 : '#ffffff'),
                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,
                        borderWidth: 1.2,
                        opacity: recoveryMode ? 0.6 : 1,



                      }



                    ]}



                    onPress={() => {
                      if (recoveryMode) {
                        setSnackbarMessage(t("recovery mode中は開講年度を変更できません"));
                        setSnackbarVisible(true);
                        return;
                      }

                      setAcademicYearModalVisible(true);
                    }}



                  >



                    <TextInput



                      value={t(academicYearFilter)}



                      style={[styles.select, { backgroundColor: 'transparent' }]}



                      right={<TextInput.Icon icon={() => recoveryMode ? <Ionicons name="lock-closed" size={20} color={theme.colors.onSurfaceVariant} /> : <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                      editable={false}



                      underlineColor="transparent"



                      activeUnderlineColor="transparent"



                    />



                    <View style={StyleSheet.absoluteFill} />



                  </TouchableOpacity>



                </View>







                <View style={styles.filterColumn}>



                  <Text style={[styles.filterLabel, { color: isDarkMode ? theme.colors.onSurfaceVariant : theme.colors.onSurfaceVariant }]}>{t("開講学期")}</Text>



                  <TouchableOpacity



                    style={[



                      styles.selectContainer,



                      {



                        backgroundColor: recoveryMode ? theme.colors.surfaceVariant : (isDarkMode ? theme.colors.elevation.level1 : '#ffffff'),
                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,
                        borderWidth: 1.2,
                        opacity: recoveryMode ? 0.6 : 1,



                      }



                    ]}



                    onPress={() => {
                      if (recoveryMode) {
                        setSnackbarMessage(t("recovery mode中は開講学期を変更できません"));
                        setSnackbarVisible(true);
                        return;
                      }

                      setSemesterModalVisible(true);
                    }}



                  >



                    <TextInput



                      value={t(semesterFilter)}



                      style={[styles.select, { backgroundColor: 'transparent' }]}



                      right={<TextInput.Icon icon={() => recoveryMode ? <Ionicons name="lock-closed" size={20} color={theme.colors.onSurfaceVariant} /> : <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                      editable={false}



                      underlineColor="transparent"



                      activeUnderlineColor="transparent"



                    />



                    <View style={StyleSheet.absoluteFill} />



                  </TouchableOpacity>



                </View>



              </View>







              {/* 3行目: 学部・カテゴリ */}



              <View style={styles.filterRow}>



                <View style={styles.filterColumn}>



                  <Text style={[styles.filterLabel, { color: isDarkMode ? theme.colors.onSurfaceVariant : theme.colors.onSurfaceVariant }]}>{t("学部")}</Text>



                  <TouchableOpacity



                    style={[



                      styles.selectContainer,



                      {



                        backgroundColor: isDarkMode ? theme.colors.elevation.level1 : '#ffffff',



                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                        borderWidth: 1.2,



                      }



                    ]}



                    onPress={() => setFacultyModalVisible(true)}



                  >



                    <TextInput



                      value={t(facultyFilter)}



                      style={[styles.select, { backgroundColor: 'transparent' }]}



                      right={<TextInput.Icon icon={() => <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                      editable={false}



                      underlineColor="transparent"



                      activeUnderlineColor="transparent"



                    />



                    <View style={StyleSheet.absoluteFill} />



                  </TouchableOpacity>



                </View>



                <View style={styles.filterColumn}>



                  <Text style={[styles.filterLabel, { color: isDarkMode ? theme.colors.onSurfaceVariant : theme.colors.onSurfaceVariant }]}>{t("カテゴリ")}</Text>



                  <TouchableOpacity



                    style={[



                      styles.selectContainer,



                      {



                        backgroundColor: isDarkMode ? theme.colors.elevation.level1 : '#ffffff',



                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                        borderWidth: 1.2,



                      }



                    ]}



                    onPress={() => setCategoryModalVisible(true)}



                  >



                    <TextInput



                      value={t(categoryFilter)}



                      style={[styles.select, { backgroundColor: 'transparent' }]}



                      right={<TextInput.Icon icon={() => <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                      editable={false}



                      underlineColor="transparent"



                      activeUnderlineColor="transparent"



                    />



                    <View style={StyleSheet.absoluteFill} />



                  </TouchableOpacity>



                </View>



              </View>







              {categoryFilter === '言語' && (



                <View style={styles.filterRow}>



                  <View style={styles.filterColumn}>



                    <Text style={[styles.filterLabel, { color: isDarkMode ? theme.colors.onSurfaceVariant : theme.colors.onSurfaceVariant }]}>{t("言語区分")}</Text>



                    <TouchableOpacity



                      style={[



                        styles.selectContainer,



                        {



                          backgroundColor: isDarkMode ? theme.colors.elevation.level1 : '#ffffff',



                          borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                          borderWidth: 1.2,



                        }



                      ]}



                      onPress={() => setLanguageSubcategoryModalVisible(true)}



                    >



                      <TextInput



                        value={t(languageSubcategoryFilter)}



                        style={[styles.select, { backgroundColor: 'transparent' }]}



                        right={<TextInput.Icon icon={() => <MaterialCommunityIcons name="chevron-down" size={20} color={theme.colors.onSurfaceVariant} />} />}



                        editable={false}



                        underlineColor="transparent"



                        activeUnderlineColor="transparent"



                      />



                      <View style={StyleSheet.absoluteFill} />



                    </TouchableOpacity>



                  </View>



                </View>



              )}











              {/* 4行目: オンデマンド (ラジオボタン風トグル) と リセットボタン */}



              <View style={[styles.filterRow, { marginBottom: 12 }]}>



                <View style={styles.filterColumn}>



                  <TouchableOpacity



                    style={[



                      styles.ondemandToggle,



                      {



                        backgroundColor: isDarkMode ? theme.colors.elevation.level1 : '#ffffff',



                        borderColor: isDarkMode ? '#4A5568' : theme.colors.outlineVariant,



                        borderWidth: 1.2,



                      }



                    ]}



                    activeOpacity={0.7}



                    onPress={() => setOndemandFilter(ondemandFilter === 'オンデマンド' ? 'すべて' : 'オンデマンド')}



                  >



                    <View style={{ marginLeft: -8 }}>



                      <RadioButton



                        value={t('オンデマンド')}



                        status={ondemandFilter === 'オンデマンド' ? 'checked' : 'unchecked'}



                        onPress={() => setOndemandFilter(ondemandFilter === 'オンデマンド' ? 'すべて' : 'オンデマンド')}



                        color={isDarkMode ? theme.colors.primary : "#4A5568"}



                      />



                    </View>



                    <Text style={[styles.ondemandToggleText, { color: theme.colors.onSurface }]} numberOfLines={1}>{t("オンデマンド")}</Text>



                  </TouchableOpacity>



                </View>







                <View style={styles.filterColumn}>



                  <TouchableOpacity



                    style={[



                      styles.resetButton,



                      {



                        borderColor: '#e75480',



                        backgroundColor: isDarkMode ? 'transparent' : '#ffffff',



                        borderWidth: 1.2,



                      }



                    ]}



                    onPress={handleResetFilters}



                    activeOpacity={0.7}



                  >



                    <Text style={{ color: '#e75480', fontSize: 13, fontWeight: 'bold' }}>{t("条件をリセット")}</Text>



                  </TouchableOpacity>



                </View>



              </View>







              {/* Search button removed because we use search-as-you-type */}



            </View>



          }



          ListFooterComponent={<View style={{ height: 100 }} />}



          contentContainerStyle={styles.listContentContainer}



          ListEmptyComponent={



            <View style={styles.emptyContainer}>



              <Text style={styles.emptyText}>{t("該当する授業はありません。")}</Text>



            </View>



          }



        />



      )



      }







      {recoveryMode && !recoveryFromUnavailable && (
        <TouchableOpacity
          style={{
            backgroundColor: recoveryColors.recovery,
            paddingVertical: 16,
            alignItems: 'center',
            justifyContent: 'center',
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            elevation: 8,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: -2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
          }}
          onPress={() => navigation.navigate('ReviewManagement')}
          activeOpacity={0.8}
        >
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Ionicons name="create-outline" size={22} color={recoveryColors.onRecovery} style={{ marginRight: 8 }} />
            <Text style={{ color: recoveryColors.onRecovery, fontSize: 18, fontWeight: 'bold' }}>
              {isGradeRecovery ? t("成績を入力する") : t("レビューを投稿する")}
            </Text>
          </View>
        </TouchableOpacity>
      )}

<Snackbar
        wrapperStyle={{ zIndex: 100, elevation: 100, paddingBottom: recoveryMode ? 60 : 0 }}



        visible={snackbarVisible}



        onDismiss={() => setSnackbarVisible(false)}



        duration={Snackbar.DURATION_SHORT}



        style={[styles.snackbar, { zIndex: 100, elevation: 100 }]}



      >



        {snackbarMessage}



      </Snackbar>

    </View >



    </>
  );



};















const styles = StyleSheet.create({



  container: {



    flex: 1,



  },



  card: {



    marginHorizontal: 10,



    marginVertical: 5,



    elevation: 2,



    shadowColor: '#000',



    shadowOffset: { width: 0, height: 1 },



    shadowOpacity: 0.22,



    shadowRadius: 2.22,



  },



  cardTitle: {



    fontSize: 18,



    fontWeight: 'bold',



    marginBottom: 5,



  },



  cardSubtitle: {



    fontSize: 16,



    color: 'gray',



    marginBottom: 8,



  },



  cardText: {



    fontSize: 14,



    marginBottom: 3,



  },



  buttonContainer: {



    flexDirection: 'row',



    justifyContent: 'space-around',



    marginTop: 10,



  },



  button: {



    flex: 1,



    marginHorizontal: 4,



  },



  addedButton: {



  },



  conflictButton: {



    borderColor: 'orange',



  },



  header: {



    backgroundColor: '#e75480',



    flexDirection: 'row',



    justifyContent: 'space-between',



    alignItems: 'center',



    paddingTop: 16,



    paddingBottom: 8,



    paddingHorizontal: 16,



    elevation: 0,



  },



  title: {



    fontSize: 20,



    fontWeight: 'bold',



    color: '#fff',



  },



  recoveryTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },



  headerIcons: {



    flexDirection: 'row',



  },



  iconButton: {



    marginLeft: 16,



    padding: 8, // Added padding to increase tappable area



  },



  subHeader: {



    padding: 16,



  },



  subHeaderTitle: {



    fontSize: 24,



    fontWeight: 'bold',



  },



  searchContainer: {



    padding: 10,



    borderRadius: 8,



    marginHorizontal: 10,



    marginTop: 0,



    marginBottom: 10,



    elevation: 2,



    zIndex: 1,



  },



  searchBar: {



    marginBottom: 8,



    borderWidth: 1,



    height: 48,



    borderRadius: 24,



    elevation: 0,



  },



  filterRow: {



    flexDirection: 'row',



    marginBottom: 6,



    marginHorizontal: -4,



  },



  filterColumn: {



    flex: 1,



    marginHorizontal: 4,



  },



  filterLabel: {



    fontSize: 12,



    marginBottom: 4,



    marginLeft: 4,



  },



  selectContainer: {



    borderWidth: 1,



    borderRadius: 10,



    height: 38,



    justifyContent: 'center',



  },



  select: {



    height: 36,



    backgroundColor: 'transparent',



  },



  searchButton: {



    backgroundColor: '#e75480',



    marginTop: 10,



    width: '50%',



    alignSelf: 'center',



    marginBottom: 10,



  },



  resetButton: {



    height: 38,



    borderRadius: 20,



    justifyContent: 'center',



    alignItems: 'center',



    borderWidth: 1,



  },



  emptyMessage: {



    fontSize: 16,



    color: '#666',



    textAlign: 'center',



    padding: 32,



  },



  recoveryBanner: {



    marginHorizontal: 12,



    marginTop: 10,



    marginBottom: 8,



    borderRadius: 12,



    paddingHorizontal: 12,



    paddingVertical: 10,



    flexDirection: 'row',



    alignItems: 'center',



    gap: 8,



  },

  recoveryBannerTextWrap: {



    flex: 1,



  },

  recoveryBannerTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },

  recoveryBannerTitle: {



    fontSize: 14,



    fontWeight: '700',



  },

  recoveryBannerDescription: {



    fontSize: 12,



    lineHeight: 18,



  },

  recoveryRetryButton: {
    marginTop: 10,
    alignSelf: 'flex-start',
  },

  recoveryExitButton: {



    borderRadius: 8,



  },

  radioGroup: {



    flexDirection: 'row',



    alignItems: 'center',



    flexWrap: 'wrap',



  },



  radioButtonItem: {



    flexDirection: 'row',



    alignItems: 'center',



    marginRight: 16,



  },



  ondemandToggle: {



    flexDirection: 'row',



    alignItems: 'center',



    borderWidth: 1,



    borderRadius: 10,



    height: 38,



    paddingHorizontal: 8,



  },



  ondemandToggleText: {



    fontSize: 14,



    marginLeft: 4,



  },



  loadingContainer: {



    flex: 1,



    justifyContent: 'center',



    alignItems: 'center',



  },



  snackbar: {



  },



  scrollContainer: {



    paddingBottom: 20,



  },



  modalContainer: {



    padding: 20,



    margin: 20,



    borderRadius: 8,



    maxHeight: '80%',



  },



  modalTitle: {



    fontSize: 18,



    fontWeight: 'bold',



    marginBottom: 16,



  },



  modalOption: {



    flexDirection: 'row',



    justifyContent: 'space-between',



    alignItems: 'center',



    paddingVertical: 12,



    borderBottomWidth: 1,



  },



  selectedOption: {



  },



  modalOptionText: {



    fontSize: 16,



  },



  selectedOptionText: {



    color: '#e75480',



    fontWeight: 'bold',



  },



  listContentContainer: {



    paddingBottom: 20,



  },



  emptyContainer: {



    flex: 1,



    justifyContent: 'center',



    alignItems: 'center',



    marginTop: 50,



  },



  emptyText: {



    fontSize: 16,



    color: 'gray',



  },



  segmentedButtons: {



    marginBottom: 4,



  },



  customContainer: {



    flex: 1,



    padding: 16,



  },



  customCard: {



    paddingVertical: 8,



  },



  customCardTitle: {



    fontSize: 20,



    fontWeight: 'bold',



    marginBottom: 8,



  },



  customCardDescription: {



    fontSize: 14,



    marginBottom: 16,



    lineHeight: 20,



  },



  customInput: {



    marginBottom: 16,



    backgroundColor: 'transparent',



  },



  customSelectRow: {



    flexDirection: 'row',



    justifyContent: 'space-between',



    marginBottom: 24,



  },



  customSelectCol: {



    flex: 1,



    marginHorizontal: 4,



  },



  customLabel: {



    fontSize: 14,



    marginBottom: 6,



    marginLeft: 4,



  },



  customAddButton: {



    paddingVertical: 6,



    borderRadius: 8,



  },



  templateActions: {



    flexDirection: 'row',



  },



  sectionHeader: {



    fontSize: 20,



    fontWeight: 'bold',



    marginBottom: 12,



  },



  cardSection: {



    marginTop: 20,



    marginBottom: 8,



  },



  cardGrid: {



    flexDirection: 'row',



    flexWrap: 'wrap',



    marginHorizontal: -5,



  },



  favoriteCard: {



    width: '47%',



    margin: '1.5%',



    backgroundColor: '#fff',



    elevation: 2,



    borderWidth: 1,



    borderColor: '#eee',



    borderRadius: 8,



  },



  favoriteCardContent: {



    padding: 8,



    flexDirection: 'row',



    alignItems: 'flex-start',



  },



  favoriteCardTitle: {



    fontSize: 14,



    fontWeight: 'bold',



    marginBottom: 2,



  },



  favoriteCardRoom: {



    fontSize: 11,



    color: 'gray',



  },



  savedBadge: {



    backgroundColor: 'rgba(231,84,128,0.15)',



    borderRadius: 12,



    paddingHorizontal: 8,



    paddingVertical: 2,



    marginLeft: 8,



    marginBottom: 12,



  },



  savedBadgeText: {



    color: '#e75480',



    fontSize: 13,



    fontWeight: 'bold',



  },



  savedCardRow: {



    flexDirection: 'row',



    alignItems: 'center',



    paddingHorizontal: 14,



    paddingVertical: 12,



    borderRadius: 14,



    gap: 12,



    elevation: 1,



    shadowColor: '#000',



    shadowOffset: { width: 0, height: 1 },



    shadowOpacity: 0.06,



    shadowRadius: 3,



  },



  savedCardBadge: {



    width: 30,



    height: 30,



    borderRadius: 15,



    justifyContent: 'center',



    alignItems: 'center',



    borderWidth: 1.5,



    borderColor: '#e75480',



    flexShrink: 0,



  },



  savedCardBadgeText: {



    color: '#e75480',



    fontSize: 13,



    fontWeight: 'bold',



  },



  savedCardName: {



    fontSize: 15,



    fontWeight: '600',



  },



  savedCardMeta: {



    fontSize: 12,



  },



  savedCardDeleteBtn: {



    padding: 8,



    justifyContent: 'center',



    alignItems: 'center',



    flexShrink: 0,



  },




});







export default CoursesScreen;


